/* @flow */

import * as React from 'react';
import { useCallback, useRef } from 'react';

import type { ModalState } from '../../../redux/modal/reducers';

import ButtonFX from '../../buttons/ButtonFX';
import { WidthKind } from '../../buttons/types';
import Modal, { ModalView } from '../modal';
import './MessageModal.css';

export type MESSAGE_MODAL_TYPE = {
  buttonText: string,
  message: string,
  title: string,
};

const MessageModal = ({ ariaLabel, messageData }: ModalState): React.Node => {
  const modalRef = useRef<ModalView | null>(null);

  const setModalRef = useCallback((instance: ModalView | null) => {
    modalRef.current = instance;
  }, []);

  const handleOnClick = useCallback(() => {
    modalRef.current?.close();
  }, []);

  if (!messageData) {
    return null;
  }

  const { buttonText, message, title } = messageData;

  return (
    <Modal ariaLabel={ariaLabel} canCloseOnEscape={false} canCloseOnOverlayClick={false} className='message' hasCloseButton={false} header={title} innerRef={setModalRef} isAlert>
      <div className='messageContainer'>
        <div className='messageContent'>
          {message.split('\n').map((line, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={i}>{line}</div>
          ))}
        </div>
        <ButtonFX autoFocus onClick={handleOnClick} widthKind={WidthKind.Stretched}>
          {buttonText}
        </ButtonFX>
      </div>
    </Modal>
  );
};

export default MessageModal;
